// extracted by mini-css-extract-plugin
module.exports = {"layout":"ChipsBarResults_layout__6onKQ","results":"ChipsBarResults_results__pcQdt","slider":"ChipsBarResults_slider__hdGWf","rotation":"ChipsBarResults_rotation__yzHp2"};